import { render, staticRenderFns } from "./MoreInfoModal.vue?vue&type=template&id=ff56c132&"
import script from "./MoreInfoModal.vue?vue&type=script&lang=js&"
export * from "./MoreInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports